import React from 'react';
import HeroSection from '../components/home/HeroSection';
import AboutTeaser from '../components/home/AboutTeaser';
import BlogCta from '../components/home/BlogCta';

function HomePage({ navigateTo }) {
  return (
    <main className="flex-grow">
      <HeroSection navigateTo={navigateTo} />
      <AboutTeaser navigateTo={navigateTo} />
      <BlogCta navigateTo={navigateTo} />
    </main>
  );
}

export default HomePage; 